import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { RouterModule } from '@angular/router';
import {
  AgrPrimaryActionModule,
  AgrPageDetailModule,
  AgrResponsiveActionsModule,
} from '@next/core-lib/components';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { AutomaticFlowSchedulerComponent } from './components/automatic-flow-scheduler-group/automatic-flow-scheduler.component';
import { ControlRoomRoutingModule } from './control-room-routing.module';
import { ControlRoomComponent } from './control-room.component';
import { SharedModule } from '../shared/shared.module';

import { ControlRoomEffects } from './store/control-room.effects';
import { controlRoomFeature } from './store/control-room.feature';

@NgModule({
  declarations: [ControlRoomComponent, AutomaticFlowSchedulerComponent],
  imports: [
    SharedModule,
    ControlRoomRoutingModule,
    MatToolbarModule,
    MatIconModule,
    MatCheckboxModule,
    AgrPrimaryActionModule,
    AgrPageDetailModule,
    MatListModule,
    MatInputModule,
    MatButtonModule,
    MatTableModule,
    RouterModule,
    AgrResponsiveActionsModule,
  ],
  providers: [provideState(controlRoomFeature), provideEffects([ControlRoomEffects])],
})
export class ControlRoomModule {}
